import React from "react";

// TODO : Add other svg patterns and move this to the marketing storybook
const CloseIconSvg = () => (
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h32v32H0z" />
      <path
        className="change-on-hover"
        d="M6.354 5.646l5.303 5.304 5.303-5.304a.5.5 0 0 1 .707.708l-5.303 5.303 5.303 5.303a.5.5 0 0 1-.707.707l-5.303-5.303-5.303 5.303a.5.5 0 0 1-.708-.707l5.304-5.303-5.304-5.303a.5.5 0 1 1 .708-.708z"
        fill="#757782"
      />
    </g>
  </svg>
);

export default CloseIconSvg;
